module.exports = __webpack_public_path__ + "img/ic_xiaozi.fdf55eb8.svg";